import QRCode from 'qrcode';
import { toast } from 'sonner';
import { openPrintWindow } from '@/lib/printWindow';

// QRラベル印刷 — スキャンすると備品詳細を直接開く。
export async function printBihinQrLabel({ id, no, name, sub }) {
  const url = `${window.location.origin}/bihin/items?open=${id}`;
  const dataUrl = await QRCode.toDataURL(url, { width: 240, margin: 1 });
  const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>QRラベル ${no || ''}</title>
<style>
  @page { size: 70mm 40mm; margin: 2mm; }
  body { font-family: sans-serif; margin: 0; }
  .label { display: flex; align-items: center; gap: 4mm; padding: 2mm; width: 66mm; height: 36mm; box-sizing: border-box; border: 1px dashed #ccc; }
  .qr { width: 30mm; height: 30mm; }
  .info { flex: 1; min-width: 0; }
  .no { font-family: monospace; font-weight: bold; font-size: 11pt; }
  .name { font-size: 9pt; font-weight: bold; margin-top: 1mm; word-break: break-all; }
  .sub { font-size: 7pt; color: #555; margin-top: 1mm; word-break: break-all; }
  @media print { .label { border: none; } }
</style></head><body>
<div class="label">
  <img class="qr" src="${dataUrl}" alt="QR" />
  <div class="info">
    <div class="no">${no || ''}</div>
    <div class="name">${(name || '').replace(/</g, '&lt;')}</div>
    ${sub ? `<div class="sub">${String(sub).replace(/</g, '&lt;')}</div>` : ''}
  </div>
</div>
</body></html>`;
  const w = openPrintWindow(html, { features: 'width=420,height=320' });
  if (!w) toast.error('ポップアップがブロックされました。ブラウザの設定でこのサイトのポップアップを許可してください');
}
